import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { style } from './cookie-overlay.styles';

@customElement('sbk-cookie-overlay')
export class SbkCookieOverlay extends LitElement {

    @property()
    overlay = '';

    static get styles() {
        return style;
    }


    render() {
        return this.overlay === '' ? this.renderBanner() : this.renderBackgroundImage()
  }

  renderBackgroundImage() {
    const description = window.cookieconsent_options?.overlay?.text
        const submitButtonText = window.cookieconsent_options?.overlay?.btn
        const dataPrivacyLinkText =
            window.cookieconsent_options?.overlay?.dataPrivacy
        const cookieConsentType = 'thirdParty'
        return html`
            <div class="cookie-consent-overlay-background-image" style="background-image: url('${this.overlay}')">
                <div class="cookie-consent-overlay-background"></div>
                <div class="cookie-consent-overlay-inner">
                    <div class="cookie-consent-overlay-inner-container banner-bg-emphasised">
                        <div class="cookie-consent-overlay-description">
                            ${description}
                            <sbk-link href="/service-navigation/datenschutz/">${dataPrivacyLinkText}</sbk-link>
                        </div>
                        <div class="cookie-consent-overlay-button">
                            <sbk-button @click=${this._onClick} class="cookie-consent-overlay-submit"
                                        data-cookieconsent=${cookieConsentType}>
                                ${submitButtonText}
                            </sbk-button>
                        </div>
                    </div>
                </div>
            </div>
        `;
  }

  renderBanner() {
    const description = window.cookieconsent_options.overlay.text
    const submitButtonText = window.cookieconsent_options.overlay.btn
    const dataPrivacyLinkText =
        window.cookieconsent_options.overlay.dataPrivacy
    const cookieConsentType = 'thirdParty'
    return html`
        <sbk-banner variant="emphasised" class="cookie-consent-overlay">
            <div class="cookie-consent-overlay-inner">
                <div class="cookie-consent-overlay-inner-container banner-bg-emphasised">
                    <div class="cookie-consent-overlay-description">
                        ${description}
                        <sbk-link href="https://www.sbk.org/service-navigation/datenschutz/">${dataPrivacyLinkText}
                        </sbk-link>
                    </div>
                    <div class="cookie-consent-overlay-button">
                        <sbk-button @click=${this._onClick} class="cookie-consent-overlay-submit"
                                    data-cookieconsent=${cookieConsentType}>
                            ${submitButtonText}
                        </sbk-button>
                    </div>
                </div>
            </div>
      </sbk-banner>
    `;
    }

    _onClick(e: Event) {
        e.preventDefault();
        const cookiesAcceptedEvent = new CustomEvent('third-party-cookies-accepted', {
            bubbles: true,
            composed: true,
        })
        this.dispatchEvent(cookiesAcceptedEvent);
    }
}